import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-phone-app-confirmation-modal-shared',
  templateUrl: './phone-app-confirmation-modal-shared.component.html'
})
export class PhoneAppConfirmationModalSharedComponent {
  @Input() visible = false;
  @Output() continueClick = new EventEmitter<void>();
}